import React from 'react';
import { useEffect } from "react";
import { Helmet } from 'react-helmet';
import "../../../../assets/css/style.css";
import Form from './Form.js'
import PatientReviews from '../../PatientReview.js';

import GetInTouch from '../../GetInTouch.js';
import FollowYt from '../../FollowYt.js'
import ContentWithImages from './ContentWithImages.js'
import DoctorBite from '../../DoctorBite.js';
import Counter from '../../../NumCounter.js';
import Breadcrumb from '../../Breadcrum.js';


export default function Index() {
  useEffect(() => {
    const metaTags = document.getElementsByTagName('meta');
    Array.from(metaTags).forEach((tag) => {
      console.log(tag);
    });
  }, []);
  return (
    <div>
          <Helmet>
            <title>Vertigo Treatment in Delhi, India | Causes, Cost, Doctor, Clinic</title>
            <meta name="description" content="Get expert vertigo treatment in Delhi, India. Learn about causes, diagnosis, therapy, and cost at top ENT and balance clinics. " />
            <meta name="keywords" content="vertigo treatment Delhi, dizziness doctor, balance disorder specialist, vertigo clinic, vestibular rehabilitation, ear balance issues" />
            <link rel="canonical" href="https://entdelhi.com/vertigo-treatment/" />
            <meta property="og:title" content="Vertigo Treatment in Delhi, India | Causes, Cost, Doctor, Clinic" />
            <meta property="og:description" content="Get expert vertigo treatment in Delhi, India. Learn about causes, diagnosis, therapy, and cost at top ENT and balance clinics. " />
            <meta name="robots" content="index, follow" />
            {/* You can add more meta tags as needed */}
          </Helmet>
     <main>
        <Breadcrumb/>
        <Form />    
        <Counter />
         <ContentWithImages/>
         <FollowYt/>
         <DoctorBite/>
         <PatientReviews/>
         
         <GetInTouch/>
      </main>
    </div>
  )
}
